<template>
    <div class="vx-card p-4">
        <div class="vx-row">
            <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="organizationBranchId" :options="branchOptions" name="status" :clearable="false"
                          :reduce="item => item.value" @input="filter">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full" @input="filter">
                </date-range-picker>
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t('menuEvent.selectDevice') }}</label>
                    <v-select class="" v-model="selectedDevice" :clearable="false"
                              :options="deviceOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
            </div>
            <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
                <div class="flex-grow" v-if="deviceId === 'camera'">
                    <label class="vs-input--label">{{ $t('menuHistory.selectCamera') }}</label>
                    <v-select class="" v-model="selectedCamera" :clearable="false"
                              :options="cameraOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="flex-grow" v-if="deviceId === 'pad'">
                    <label class="vs-input--label">{{ $t('menuEvent.selectPad') }}</label>
                    <v-select class="" v-model="selectedPad" :clearable="false"
                              :options="padsData">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
            </div>

        </div>

        <div class="customer-inout-details">
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="inOutHistoryData" :animateRows="true" :pagination="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         :onGridReady="onGridReady" :suppressPaginationPanel="true">
            </ag-grid-vue>
        </div>

        <div class="vx-row" v-if="inOutHistoryData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    inOutHistoryData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : inOutHistoryData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import DateRangePicker from '../../../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import CellRendererImgInOut from "./cell-renderer/CellRendererImgInOut";

export default {
    name: "InOutHistory",
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererImgInOut
    },

    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },

    data() {
        return {
            branchOptions: [],
            organizationBranchId: null,
            dateRange: {
                startDate: new Date(new Date().setHours(0, 0, 0, 0)),
                endDate: new Date(new Date().setHours(23, 59, 59, 999)),
            },
            gridApi: null,
            gridOptions: {
                rowHeight: 70
            },
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 80,
                },
                {
                    headerName: this.$t('menuCustomer.branch'),
                    field: 'organizationBranchName',
                    minWidth: 100,
                },
                {
                    headerName: 'Thiết bị',
                    field: 'deviceType',
                    minWidth: 150,
                },
                {
                    headerName: 'Tên thiết bị',
                    field: 'cameraName',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('menuHistory.img'),
                    field: 'imageUrl',
                    width: 150,
                    cellRendererFramework: 'CellRendererImgInOut',
                },
                {
                    headerName: 'Thời gian',
                    field: 'checkinTime',
                    minWidth: 150,
                },
            ],
            pageSize: 20,
            pageNumber: 0,
            currentPage: 1,
            totalPages: 0,
            totalElements: 0,
            inOutHistoryData: [],
            cameraOptions: [{value: null, label: this.$t('menuHistory.all')}],
            padsData: [{value: null, label: this.$t('menuHistory.all')}],
            deviceOptions: [
                {value: null, label: this.$t('menuHistory.all')},
                {value: 'camera', label: "Camera"},
                {value: 'pad', label: "Pad"},
            ],
            deviceId: null,
            cameraId: null,
            padId: null,

        }
    },

    computed: {
        selectedCamera: {
            get() {
                if (this.cameraOptions.length > 0) {
                    return {
                        label: this.cameraOptions.find(x => x.value == this.cameraId).label,
                        value: this.cameraId
                    }
                }
            },
            set(obj) {
                this.cameraId = obj.value;
                this.filter();
            }
        },
        selectedPad: {
            get() {
                if (this.padsData.length > 0) {
                    return {
                        label: this.padsData.find(x => x.value == this.padId).label,
                        value: this.padId
                    }
                }
            },
            set(obj) {
                this.padId = obj.value;
                this.filter();
            }
        },

        selectedDevice: {
            get() {
                if (this.deviceOptions.length > 0) {
                    return {
                        label: this.deviceOptions.find(x => x.value == this.deviceId).label,
                        value: this.deviceId
                    }
                }
            },
            async set(obj) {
                this.deviceId = obj.value
                await this.filter();
                if (this.deviceId === 'camera') {
                    await this.getCameraByBranch();
                    this.selectedCamera = this.cameraOptions[0];
                }
                if (this.deviceId === 'pad') {
                    await this.getHardwareDevice();
                    this.selectedPad = this.padsData[0];
                }
                if (!this.deviceId) {
                    this.cameraId = null;
                    this.padId = null;
                }
            }
        },

    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        dateRange(newDate){
            this.filter()
        }
    },

    created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        this.getInOutHistory();
    },

    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getInOutHistory();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getInOutHistory();
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getInOutHistory();
        },

        getInOutHistory() {
            let payload = {
                organizationBranchId: this.organizationBranchId,
                start: this.dateRange.startDate,
                end: this.dateRange.endDate,
                employeeId: [`${this.loyaltyCustomerId}`],
                faceTypes: ["loyalty-customer"],
                deviceType: this.deviceId,
                cameraId: this.deviceId == this.deviceOptions[1].value ? this.cameraId : this.padId,
            }

            let url = `/processor/in-out-history/all?page=${this.pageNumber}&size=${this.pageSize}`;
            this.$vs.loading();
            this.$processor.post(url, payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.inOutHistoryData = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        el.deviceType = el.deviceType.toUpperCase();
                        el.checkinTime = el.createdAt ? moment(el.createdAt).format("HH:mm DD/MM/YYYY") : null;
                        let branch = this.branchOptions.find(x => x.value == el.organizationBranchId)
                        if (branch) el.organizationBranchName = branch.label;
                        return el;
                    })
                } else {
                    this.inOutHistoryData = []
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getHardwareDevice() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                let data = {
                    organizationBranchId: this.organizationBranchId
                }
                this.padsData = [];
                this.$str.post('/device/find-by-condition', data).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.padsData = res.data.content.map(item => {
                            return {value: item.id, label: item.deviceName}
                        });
                    }
                    this.padsData.unshift({value: null, label: this.$t('menuHistory.all')})
                    this.$vs.loading.close()
                    resolve()
                }).catch(err => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })

        },
        getCameraByBranch() {
            return new Promise((resolve, reject) => {
                let url = this.organizationBranchId ? `/camera/find-by-organization-branch/${this.organizationBranchId}` : `/camera/all`
                this.$vs.loading();
                this.$crm.post(url).then((response) => {
                    this.cameraOptions = response.data.map(item => {
                        return {value: item.id, label: item.cameraName}
                    });
                    this.cameraOptions.unshift({value: null, label: this.$t('menuHistory.all')})
                    this.$vs.loading.close();
                    resolve()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },

    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style lang="scss">
.customer-inout-details .ag-theme-material .ag-ltr .ag-cell {
    line-height: 70px;
}

</style>
